<template>
    <MessageScreen
        :primaryMessageScreen="false"
        :srcImageMessage="IconDocuments"
        :isVisibleSecondaryMessage="true"
        :titleMessage="'Sua solicitação de cadastro foi enviada!'"
        :message="'Assim que for aprovado, você poderá acessar com seu login.'"
    />
    <FooterButton
        :primaryButton="false"
        :textPrimaryButton="'Quero acessar o app'"
        :confirmData="backLogin"
    />
</template>
<script>
  import MessageScreen from '../../components/MessageScreen.vue'
  import FooterButton from '../../components/FooterButton.vue'
  import { useRouter } from 'vue-router'
  import IconDocuments from '../../../../public/images/Documents.svg'
  

  export default {
      components: {
          MessageScreen,
          FooterButton,
      },
      setup() {
        const router = useRouter();
         
        const backLogin = async () => {
            window.location.href = '/entrar';
        }

        return {          
            IconDocuments,
            backLogin
        };
      }, 
  }
</script>